/**
 * Recommend module.
 * @module video/Recommend
 */

import './style.css';
import tmpl from './main.ejs';
import Events from 'f.core.event';
import Util from 'f.core.util.pc';
const pcVideoUtil = new Util();

/**
 * 推荐组件
 */
class Recommend {
    /**
     * Creates an instance of Recommend.
     * @param {object} recommend 推荐数据
     * @param {object} container 容器
     */
    constructor({recommend, container}) {
        this.data = recommend || [];
        this.container = container;
        this.state = false;
    }

    /**
     * 初始化快捷方法
     */
    initShow() {
        this.data = window.recommend || this.data;
        if (!this.state) {
            this.state = true;
            this.init();
            this.renderTo(this.container);
        }

        this.show();
    }

    /**
     * 初始化
     */
    init() {
        this.initDom();
        this.initCompontent();
        this.initEvent();
    }

    /**
     * 初始化dom
     */
    initDom() {
        this.el = $(tmpl())[0];
        this.list = $(this.el).find('#js_recommend_list');

        this.js_recommend_pageR = $(this.el).find('#js_recommend_pageR');
        this.js_recommend_pageL = $(this.el).find('#js_recommend_pageL');
        // this.title = $(this.el).find('#js_siderTop_title');
        // this.baifen = $(this.el).find('#js_siderTop_scale');
        // this.control = $(this.el).find('.siderTopControl');
        // this.time = $(this.el).find('#js_siderTop_time');
    }

    /**
     * 初始化component
     */
    initCompontent() {
        let recommendHtml = '';
        for (let i = 0, iLen = this.data.length; i < iLen; i++) {
            const item = this.data[i];
            if (i % 2 == 0) recommendHtml += '<li>';
            recommendHtml += `<div>
                    <a href="${item.pageUrl}" target="_self">
                        <img src="${item.stills}" />
                        <i></i>
                        <span class="time">${pcVideoUtil.formatTime(item.duration)}</span>
                        <em>${item.title}</em>
                    </a>
                </div>
            `;
            if (i % 2 == 1) recommendHtml += '</li>';
        }
        this.list.html(recommendHtml);
    }

    /**
     * 初始化自定义事件
     */
    initEvent() {
        const _this = this;
        this.js_recommend_pageR.on('click', () => {
            _this.recommendRun('right');
        });
        this.js_recommend_pageL.on('click', () => {
            _this.recommendRun('left');
        });
    }

    /**
     * 推荐滚动
     *
     * @param {string} type 方向
     */
    recommendRun(type) {
        const containerRight = document.getElementsByClassName('containerRight')[0];
        const containerLeft = document.getElementsByClassName('containerLeft')[0];

        /**
         * 后推荐宽度
         */
        const recommendWidth = parseInt(pcVideoUtil.getStyle(document.getElementById('js_recommend_container')).width);
        const recommendMax = 180 * pcVideoUtil.delNodes(document.getElementById('js_recommend_list')).childNodes.length;

        const change = type == 'right' ? -1 : 1;
        const recommendList = document.getElementById('js_recommend_list');
        const _curLeft = parseInt(pcVideoUtil.getStyle(recommendList).left);
        let changeLeft = _curLeft + change * (recommendWidth);

        if (type == 'left') {
            if (_curLeft == 0) return;
            changeLeft = Math.min(changeLeft, 0);
        } else if (type == 'right') {
            changeLeft = Math.max(changeLeft, -(recommendMax - recommendWidth));
        }

        recommendList.style.left = `${changeLeft}px`;

        pcVideoUtil.addClass(containerRight, 'containerHover');
        pcVideoUtil.addClass(containerLeft, 'containerHover');

        if (changeLeft == 0) {
            pcVideoUtil.removeClass(containerLeft, 'containerHover')
        } else if (changeLeft == -(recommendMax - recommendWidth)) {
            pcVideoUtil.removeClass(containerRight, 'containerHover');
        }
    }

    /**
     * 隐藏组件
     */
    hide() {
        this.el.style.display = 'none';
    }

    /**
     * 显示组件
     */
    show() {
        this.el.style.display = 'block';
    }

    /**
     * 渲染组件
     * @param {HTMLELEMENT} parentNode
     */
    renderTo(parentNode) {
        parentNode.appendChild(this.el);
    }

    /**
     * 销毁组件
     */
    destory() {
        this.el.parentNode.removeChild(this.el);
    }
}

Events.mixTo(Recommend);
export default Recommend;



// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/modules/recommend/index.js